var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQlWebmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48.727,
    height: 48.727,
    viewBox: "0 0 48.727 48.727",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h48.727v48.727H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.545 4H6.061A4.055 4.055 0 0 0 2.02 8.061L2 32.424a4.072 4.072 0 0 0 4.061 4.061h32.484a4.072 4.072 0 0 0 4.061-4.061V8.061A4.072 4.072 0 0 0 38.545 4zm0 8.121L22.3 22.272 6.061 12.121v-4.06L22.3 18.212 38.545 8.061z",
    transform: "translate(2.061 4.121)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQlWebmail);
export default __webpack_public_path__ + "static/media/ql-webmail.187b21a9f033c3f5f6aff55aaef3b578.svg";
export { ForwardRef as ReactComponent };